/* eslint-disable @typescript-eslint/no-unused-vars */
import { useFormContext } from "components/Form";
import { Button } from "components/Button";
import { useStepperContext } from "components/Steps";
import { AutoComplete } from "components/hookForm/AutoComplete";
import { useEffect, useMemo, useState } from "react";

import * as dateFns from "date-fns";

import { ArrowForward as IconArrowNext } from "@material-ui/icons";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";

import * as S from "./styles";
import { Input } from "components/hookForm/Input";
import { DatePicker } from "components/hookForm/DatePicker";
import { DefaultFooter } from "components/DefaultFooter";
import { InputCurrency } from "components/hookForm/InputCurrency";
import { MediaMatch } from "components/MediaMatch";
import { Tooltip } from "@material-ui/core";

export function CreditDataForm() {
  const {
    methodsForm: {
      formState: { errors },
      watch,
      setValue,
      trigger,
    },
    validateFields,
  } = useFormContext();

  const dateBirthdayWatch = watch("dateBirthday");

  const [showDeadline, setShowDeadline] = useState(false);
  const [deadLineMonths, setDeadLineMonths] = useState(0);

  useEffect(() => {
    if (!dateBirthdayWatch || !!errors.dateBirthday) {
      setShowDeadline(false);
      setValue("deadline", null);
      return;
    }

    setShowDeadline(true);

    const age = dateFns.differenceInYears(
      new Date(),
      new Date(dateBirthdayWatch)
    );

    let months = (80 - age) * 12;

    if (months > 240) {
      months = 240;
    }

    setDeadLineMonths(months);
  }, [dateBirthdayWatch, errors.dateBirthday, setValue]);

  const { goToNextStep, goToPreviousStep } = useStepperContext();

  async function handleNextStep() {
    const fields = [
      "city",
      "propertyAmount",
      "creditAmount",
      "dateBirthday",
      "deadline",
    ];

    const isFieldsValids = await validateFields(fields);

    if (isFieldsValids) {
      goToNextStep();
    }
  }

  const statesOptions = useMemo(() => {
    return [
      { value: "AC", label: "Acre" },
      { value: "AL", label: "Alagoas" },
      { value: "AP", label: "Amapá" },
      { value: "AM", label: "Amazonas" },
      { value: "BA", label: "Bahia" },
      { value: "CE", label: "Ceará" },
      { value: "DF", label: "Distrito Federal" },
      { value: "ES", label: "Espírito Santo" },
      { value: "GO", label: "Goiás" },
      { value: "MA", label: "Maranhão" },
      { value: "MT", label: "Mato Grosso" },
      { value: "MS", label: "Mato Grosso do Sul" },
      { value: "MG", label: "Minas Gerais" },
      { value: "PA", label: "Pará" },
      { value: "PB", label: "Paraíba" },
      { value: "PR", label: "Paraná" },
      { value: "PE", label: "Pernambuco" },
      { value: "PI", label: "Piauí" },
      { value: "RJ", label: "Rio de Janeiro" },
      { value: "RN", label: "Rio Grande do Norte" },
      { value: "RS", label: "Rio Grande do Sul" },
      { value: "RO", label: "Rondônia" },
      { value: "RR", label: "Roraima" },
      { value: "SC", label: "Santa Catarina" },
      { value: "SP", label: "São Paulo" },
      { value: "SE", label: "Sergipe" },
      { value: "TO", label: "Tocantins" },
    ];
  }, []);

  const deadLinesOptions = useMemo(() => {
    const monthsList = Array.from(
      { length: deadLineMonths },
      (_, i) => i + 1
    ).filter((item) => item >= 12);

    return monthsList
      .sort((numberA, numberB) => numberB - numberA)
      .map((month) => {
        let stringMonth = "meses";

        if (month === 1) {
          stringMonth = "mês";
        }

        return {
          value: `${month} ${stringMonth}`,
          label: `${month} ${stringMonth}`,
        };
      });
  }, [deadLineMonths]);

  return (
    <S.Container>
      <S.Title>
        Agora, necessitamos de algumas informações essenciais para o cálculo de
        seu crédito.
      </S.Title>

      <S.WrapperForm>
        <div className="grid-3">
          <AutoComplete
            name="city"
            customLabel="Localização do imóvel*"
            options={statesOptions}
            propertyLabel="label"
            error={!!errors.city}
            helperText={errors.city?.message}
            defaultValue="ES"
          />

          <InputCurrency
            max={9999999999}
            name="propertyAmount"
            placeholder="R$"
            customLabel="Valor aproximado do imóvel*"
            error={!!errors.propertyAmount}
            helperText={errors.propertyAmount?.message}
            onChangeCapture={() =>
              !!errors.creditAmount && trigger("creditAmount")
            }
          />

          <InputCurrency
            max={9999999999}
            name="creditAmount"
            placeholder="R$"
            customLabel="Valor do empréstimo desejado*"
            error={!!errors.creditAmount}
            helperText={errors.creditAmount?.message}
          />
        </div>

        <div className="grid-3">
          <Tooltip
            title="Se casal, o de maior idade"
          >
            <div>
              <DatePicker
                name="dateBirthday"
                customLabel="Data de nascimento *"
                placeholder="dd/mm/aaaa"
                helperText={errors.dateBirthday?.message}
                error={!!errors.dateBirthday}
                fullWidth={true}
              />
            </div>
          </Tooltip>
          {showDeadline && (
            <AutoComplete
              name="deadline"
              customLabel="Prazo desejado para pagar*"
              options={deadLinesOptions}
              propertyLabel="label"
              error={!!errors.deadline}
              helperText={errors.deadline?.message}
            />
          )}
        </div>
      </S.WrapperForm>

      <S.WrapperButtons>
        <Button
          onClick={goToPreviousStep}
          startIcon={<IconArrowBack />}
          variant="outlined"
        >
          VOLTAR
        </Button>
        <Button onClick={handleNextStep} endIcon={<IconArrowNext />}>
          AVANÇAR
        </Button>
      </S.WrapperButtons>

      <MediaMatch greaterThan="medium">
        <DefaultFooter />
      </MediaMatch>
    </S.Container>
  );
}
